export function getAcceptTypes(accept: string): {
  [key: string]: string[];
} {
  const types = accept.split(',');
  const accepted = Object.entries(mimeTypes)
    .filter(([key]) => types.includes(key))
    .map(([key, value]) => ({[key]: value}));
  return Object.assign({}, ...accepted);
}

export function getAcceptLabels(accept: string): [string, string] {
  const types = accept
    .split(',')
    .map((t) =>
      mimeTypes[t].map((mt) => mt.replace(/(?:\s+)|(?:\.)/g, '').toUpperCase())
    )
    .flat();

  const full = types.join(', ');
  const short =
    types.length > 8 ? types.slice(0, 8).join(', ').concat(' and more') : full;

  return [short, full];
}

const mimeTypes: {[key: string]: string[]} = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  'image/bmp': ['.bmp'],
  'image/tiff': ['.tif', '.tiff'],
  'application/zip': ['.zip'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    '.pptx',
  ],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
  'video/avi': ['.avi'],
  'video/h264': ['.h264'],
  'video/quicktime': ['.mov'],
  'video/mp4': ['.mp4'],
  'video/mpeg': ['.mpg', '.mpeg'],
  'video/x-ms-wmv': ['.wmv'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'application/pdf': ['.pdf'],
  'text/plain': ['.txt'],
  'application/dxf': ['.dxf'],
  'application/autocad_dwg': ['.dwg'],
  'application/autocad_dxf': ['.dxf'],
  'application/revit': ['.rvt'],
  'application/revit_family': ['.rft'],
  'application/obj': ['.obj'],
  'application/xyz': ['.xyz'],
  'application/kmz': ['.kmz'],
  'application/kml': ['.kml'],
  'application/shp': ['.shp'],
  'application/mxd': ['.mxd'],
  'application/nfo': ['.nfo'],
  'application/p4d': ['.p4d'],
  'application/cam': ['.cam'],
  'application/ssk': ['.ssk'],
  'application/prj': ['.prj'],
  'application/p4b': ['.p4b'],
  'application/p4drec': ['.p4drec'],
  'application/las': ['.las'],
  'image/svg+xml': ['.svg'],
  'application/fbx': ['.fbx'],
  'application/dat': ['.dat'],
  'application/sbf': ['.sbf'],
  'image/jxl': ['.jxl'],
  'image/efly': ['.efly'],
  'application/log': ['.log'],
  'application/thm': ['.thm'],
  'application/ts': ['.ts'],
  'application/x-msi': ['.msi'],
};
